import firebase from 'firebase';

var configFirebase = {
    apiKey: "AIzaSyAv4swisjHqpuxVFAxG6rhoXzauT-j52Y4",
    authDomain: "ilgu-34beb.firebaseapp.com",
    databaseURL: "https://ilgu-34beb.firebaseio.com",
    projectId: "ilgu-34beb",
    storageBucket: "ilgu-34beb.appspot.com",
    messagingSenderId: "1021997125247",
    appId: "1:1021997125247:web:2bf43dc9a9c039aaad394a",
    measurementId: "G-VV0THW07E4"
};

firebase.initializeApp(configFirebase);
var provider = new firebase.auth.GoogleAuthProvider();
provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
firebase.auth().useDeviceLanguage();
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)

export default firebase;

